import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { HelperService } from '../helper/helper.service';
import { EnvironmentConfigService } from '../shared/environment-config.service';

@Injectable({
  providedIn: 'root'
})
export class CheckoutServiceService {

  // http://api.travelx.ai/api/checkoutcart?location_id=5216&airportid=1&cartids=7786,7787&ptype=food&storeid=3232&deviceid=PWAGYDwsiuMbX&key=qw1op5cv8j0d&pid=gmr&platformid=PWAGYDwsiuMbX&platform=android&novalidation=1&version=2
  apiConfig = {
    baseUrl: 'https://api2.travelx.ai',
    checkoutPath: '/api/checkoutcart',
  };

  apiParams: any;
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    })
  };

  constructor(private httpClient: HttpClient, private helperService: HelperService, private envService: EnvironmentConfigService) {
    this.initApiParams();
  }

  public get checkoutServiceApi(): string {
    let finalRequestParams = { ...this.envService.getDefaultApiParams(), ...this.apiParams };
    // tslint:disable-next-line: max-line-length
    return this.checkoutServiceApi = `${this.envService.checkoutCartApi()}?${this.helperService.serializeToGetParams(finalRequestParams)}`;
  }
  public set checkoutServiceApi(value: string) {
  }


  initApiParams() {
    this.apiParams = {};
  }
  checkoutCart(date: string, storeId, autoCheckoutData?: any) {
    this.apiParams.storeId = storeId;
    this.apiParams.ondate = date;
    if (autoCheckoutData) {
      this.apiParams.ACFResp = autoCheckoutData;
    }
    return this.httpClient.get<any>(this.checkoutServiceApi);
  }
}
